const config = {
    API_V2_0: "https://api.dev.ladiuid.com/2.0",
    API_LADIPAGE_V2_0: "https://api.dev.ladipage.com/2.0",
    API_LADISALE_V2_0: "https://api.dev.ladisales.com/2.0",
}

export default config;
